import { useMemo } from 'react';

const ELEMENTS = [
	{ label: 'Fire', value: 'fire' },
	{ label: 'Earth', value: 'earth' },
	{ label: 'Air', value: 'air' },
	{ label: 'Water', value: 'water' },
];

const AlchemyScore = ({ ingredients, product }) => {
	//const _scoreIngredients = useMemo(() => ingredients.filter((ing) => ing?.id && !ing?.isAgent), [ingredients]);
	const score = useMemo(() => ingredients.reduce((acc, ing, i) => {
		//console.log({ing, acc})
		if (!ing?.quality) return acc;
		if (ing?.isAgent) return acc;
		const multi = i === 0 ? 2 : 1;
		return {
			air: (acc.air + ing.air * multi),
			earth: (acc.earth + ing.earth * multi),
			fire: (acc.fire + ing.fire * multi),
			water: (acc.water + ing.water * multi),
			quality: (acc.quality + ing.quality * multi),
		};
	}, { air: 0, earth: 0, fire: 0, water: 0, quality: 0 }), [ingredients]);
	const agent = ingredients.find((ing) => ing?.id && ing?.isAgent);
	//console.log({score, ingredients, agent})
	score.quality = Math.floor(score.quality / 5 + (agent?.quality || 0));
	const qualityColor = (product.minQuality > score.quality) ? 'light-error' : 'gray-100';
	return (
		<div className={'alchemy-score'}>
			<h3>Alchemy Score</h3>
			<div>
				<h3 style={{ marginBottom: 0 }}>Quality:</h3>
				<p><strong><span className={`quality-score-bar needs-${product?.minScore ? product.element.toLowerCase() : 'none'} ele-box has-${qualityColor}-background-color has-gray-900-color`}>{score.quality}</span></strong></p>
			</div>
			<h3 style={{ marginBottom: 0 }}>Score:</h3>
			<div className="grid grid-xs-4 grid-sm-4">
				{ELEMENTS.map((ele) => {
					const hasAgentScore = agent && Object.keys(agent).includes(ele.value)
					//console.log({hasAgentScore, ele, score, agent})
					const eleScore = score[ele.value] + (hasAgentScore ? agent[ele.value] : 0);
					const className = [];
					if (product.minScore > 0 && ele.value === product.element.toLowerCase()) {
						className.push('is-required');

						if (eleScore >= product.minScore) {
							className.push('has-required-min-score');
						}
					}
					return (
						<p key={ele.value} className={className.join(' ')}>
							<strong>{ele.label}: <span className={`ele-box ${ele.value}`}>{eleScore}</span></strong>
						</p>
					);
				})}
			</div>
		</div>
	);
};

export default AlchemyScore;
